import {
  Box,
  CircularProgress,
  FormControl,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { FILING_REPORT_STATUS_OPTIONS } from "./filingReportStatusOptions";

type FilingReportAddStatusCellProps = {
  needsAttention: boolean;
  saving: boolean;
  onAddStatus: (status: string) => void;
};

export default function FilingReportAddStatusCell({
  needsAttention,
  saving,
  onAddStatus,
}: FilingReportAddStatusCellProps) {
  const accentColor = needsAttention ? "error.main" : "text.secondary";

  return (
    <FormControl size="small" fullWidth disabled={saving} sx={{ minWidth: 200 }}>
      <Select
        displayEmpty
        value=""
        onChange={(e) => onAddStatus(e.target.value)}
        variant="outlined"
        sx={{
          "& .MuiSelect-select": { py: 0.75 },
        }}
        renderValue={() => (
          <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
            {saving ? (
              <CircularProgress size={14} />
            ) : (
              <AddIcon sx={{ fontSize: 16, color: accentColor }} />
            )}
            <Typography color={accentColor} variant="body2" fontWeight={needsAttention ? 600 : 500}>
              Add status
            </Typography>
          </Box>
        )}
      >
        {FILING_REPORT_STATUS_OPTIONS.map((option) => (
          <MenuItem key={option} value={option} sx={{ whiteSpace: "normal" }}>
            {option}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
